<template>
  <div
    v-if="popShow"
    ref="canvas-container"
    style="position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.7);z-index:99999"
    class="flexCenter"
    @click.stop=""
  >
    <div
      @click="hide"
      v-if="id == '7' || id == '8' || id == '9'"
      style="width:100%;height:100%;position:relative"
      :style="
        `background:url(${pic}) no-repeat;background-size:contain;background-position:center`
      "
    ></div>
    <div v-else class="flexAc" style="position:relative;">
      <!-- 关闭按钮 -->
      <img
        src="../assets/alert_close.png"
        style="width:4.4rem;position:absolute;top:0;right:-7.1rem;cursor: pointer;"
        @click="hide"
      />
      <!-- 绘画、擦除选择 -->
      <div style="width:4.4rem;position:absolute;bottom:0;right:-7.1rem">
        <!-- 颜色选择器，仅在绘画模式下显示 -->
        <div v-if="action_type == 'draw'" style="margin-bottom:1rem;">
          <div style="text-align:center;font-size:0.9rem;color:#ffffff;margin-bottom:0.5rem;">画笔颜色</div>
          <div class="color-selector">
            <div
              v-for="(item, index) in colorList"
              :key="index"
              class="color-item"
              :style="{background: item.color}"
              :class="{'color-selected': currentColor === item.color}"
              @click="selectColor(item.color)"
              :title="item.name"
            ></div>
          </div>
        </div>
        <div
          style="position:relative;cursor: pointer;"
          @click="setCanvasType('draw')"
        >
          <img src="../assets/mark_pencil.png" style="width:100%" />
          <img
            v-if="action_type == 'draw'"
            src="../assets/icon_selected.png"
            style="width:1.8rem;position:absolute;bottom:0;right:0"
          />
        </div>
        <div
          style="position:relative;margin-top:1rem;cursor: pointer;"
          @click="setCanvasType('eraser')"
        >
          <img src="../assets/mark_eraser.png" style="width:100%" />
          <img
            v-if="action_type == 'eraser'"
            src="../assets/icon_selected.png"
            style="width:1.8rem;position:absolute;bottom:0;right:0"
          />
        </div>
      </div>
      <!-- 上翻页 -->
      <img
        src="../assets/class_arrow_left.png"
        style="width:2.5rem;cursor: pointer;"
        @click="markPrevPic"
      />
      <!-- canvas -->
      <div
        style="background:#ffffff;border-radius:2rem;padding:0.8rem;margin:0 2.4rem"
      >
        <canvas
          class="myCanvas"
          ref="task-canvas"
          :width="canvasWidth"
          :height="canvasHeight"
          :style="'background:url(\'' + pic + '\') no-repeat'"
        ></canvas>
      </div>
      <!-- 下翻页 -->
      <img
        src="../assets/class_arrow_right.png"
        style="width:2.5rem;cursor: pointer;"
        @click="markNextPic"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PicMark',
  props: {},
  data() {
    return {
      id: '',
      pic: '',
      pic_index: 0,
      action_type: 'draw',
      popShow: false,
      canvasWidth: 0,
      canvasHeight: 0,
      canvas: null,
      ctx: null,
      currentColor: '#ff0000', // 当前选中的颜色，默认红色
      colorList: [
        { color: '#ff0000', name: '红色' },
        { color: '#00ff00', name: '绿色' },
        { color: '#0000ff', name: '蓝色' },
        { color: '#ffff00', name: '黄色' },
        { color: '#000000', name: '黑色' },
      ] // 可选颜色列表
    }
  },
  mounted() {
    let baseFontSize = getComputedStyle(window.document.documentElement)[
      'font-size'
    ].replace('px', '')
    this.canvasWidth = 50 * baseFontSize
    // this.canvasWidth = window.innerWidth * 0.7
    this.canvasHeight = 41.67 * baseFontSize
  },
  methods: {
    markPrevPic() {
      this.$emit('prev-page', this.pic_index)
    },
    markNextPic() {
      this.$emit('next-page', this.pic_index)
    },
    setCanvasType(type) {
      this.action_type = type
    },
    selectColor(color) {
      this.currentColor = color
    },
    startEventHandler(ev) {
      let coverPos = this.canvas.getBoundingClientRect()
      var x, y
      if (ev.touches && ev.touches.length > 0) {
        x = ev.touches[0].clientX - coverPos.left
        y = ev.touches[0].clientY - coverPos.top
      } else {
        x = ev.clientX - coverPos.left
        y = ev.clientY - coverPos.top
      }
      if (this.action_type == 'draw') {
        this.ctx.beginPath()
      }
      this.ctx.moveTo(x, y)
      this.canvas.addEventListener('mousemove', this.moveEventHandler, false)
      this.canvas.addEventListener('touchmove', this.moveEventHandler, false)
      this.$refs['canvas-container'].addEventListener(
        'mouseup',
        this.endEventHandler,
        false
      )
      this.$refs['canvas-container'].addEventListener(
        'touchend',
        this.endEventHandler,
        false
      )
    },
    erase(ev) {
      let coverPos = this.canvas.getBoundingClientRect()
      var targetX, targetY
      if (ev.touches && ev.touches.length > 0) {
        targetX = ev.touches[0].clientX - coverPos.left
        targetY = ev.touches[0].clientY - coverPos.top
      } else {
        targetX = ev.clientX - coverPos.left
        targetY = ev.clientY - coverPos.top
      }
      this.ctx.save()
      this.ctx.beginPath()
      this.ctx.fillStyle = '#ffffff'
      this.ctx.arc(targetX, targetY, 20, 0, Math.PI * 2, true)
      this.ctx.clip()
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
      this.ctx.restore()
    },
    draw(ev) {
      let coverPos = this.canvas.getBoundingClientRect()
      var targetX, targetY
      if (ev.touches && ev.touches.length > 0) {
        targetX = ev.touches[0].clientX - coverPos.left
        targetY = ev.touches[0].clientY - coverPos.top
      } else {
        targetX = ev.clientX - coverPos.left
        targetY = ev.clientY - coverPos.top
      }
      this.ctx.lineWidth = 1
      this.ctx.lineCap = 'round'
      this.ctx.lineJoin = 'round'
      this.ctx.shadowBlur = 1
      this.ctx.shadowColor = this.currentColor
      this.ctx.strokeStyle = this.currentColor
      this.ctx.lineTo(targetX, targetY)
      this.ctx.stroke()
    },
    moveEventHandler(ev) {
      if (this.action_type == 'draw') {
        this.draw(ev)
      } else {
        this.erase(ev)
      }
    },
    endEventHandler() {
      this.canvas.removeEventListener('mousemove', this.moveEventHandler, false)
      this.canvas.removeEventListener('touchmove', this.moveEventHandler, false)
      this.$refs['canvas-container'].removeEventListener(
        'mouseup',
        this.endEventHandler,
        false
      )
      this.$refs['canvas-container'].removeEventListener(
        'touchend',
        this.endEventHandler,
        false
      )
    },
    show(pic, index, id) {
      this.id = id
      this.pic = pic
      this.pic_index = index
      this.action_type = 'draw'
      this.currentColor = '#ff0000' // 重置为默认颜色
      this.popShow = true

      //做宽高自适应
      let picObj = document.createElement('img')
      picObj.src = pic
      picObj.onload = () => {
        this.canvasHeight = this.canvasWidth * (picObj.height / picObj.width)
      }

      this.$nextTick(() => {
        if (!this.canvas) {
          this.canvas = this.$refs['task-canvas']
          this.canvas.addEventListener(
            'mousedown',
            this.startEventHandler,
            false
          )
          this.canvas.addEventListener(
            'touchstart',
            this.startEventHandler,
            false
          )
        }
        if (!this.ctx) {
          this.ctx = this.canvas.getContext('2d')
        } else {
          this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
        }
      })
    },
    hide() {
      this.canvas = null
      this.ctx = null
      this.popShow = false
    },
    doCancle() {
      if (typeof this.cancle == 'function') {
        this.cancle()
      }
      this.hide()
    },
    doConfirm() {
      if (typeof this.success == 'function') {
        this.success()
      }
      this.hide()
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.myCanvas {
  border-radius: 1.5rem;
  background-size: 100% 100% !important;
  background-repeat: no-repeat;
}

.color-selector {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.color-item {
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
  margin: 0.2rem;
  cursor: pointer;
  border: 1px solid #ffffff;
  transition: all 0.2s;
}

.color-item:hover {
  transform: scale(1.1);
}

.color-selected {
  box-shadow: 0 0 0 2px #ffffff;
  transform: scale(1.1);
}

.cancleBtn {
  font-size: 1.4rem;
  color: #ffffff;
  height: 3.2rem;
  width: 9.4rem;
  text-align: center;
  line-height: 3.2rem;
  border-radius: 1.6rem;
  background: linear-gradient(to right, #ffa143, #ffc11d);
}

.confirmBtn {
  font-size: 1.4rem;
  color: #ffffff;
  height: 3.2rem;
  width: 9.4rem;
  text-align: center;
  line-height: 3.2rem;
  border-radius: 1.6rem;
  background: #2a9bff;
}

.cancleBtn:hover {
  background: linear-gradient(to right, #f38b22, #f38b22);
}

.confirmBtn:hover {
  background: #158ffa;
}
</style>
